export default __webpack_public_path__ + "static/media/promo_05.511212fb.jpg";